/**
 * Client helper: refine template chair script via /api/chair-script (Claude / Gateway).
 */

import { getSupabaseClient, hasSupabaseConfig } from '../lib/supabaseClient';

export async function refineChairScript({
  organizationId,
  baselineScript,
  meetingContext = {},
  accessToken = null,
  signal = null,
}) {
  const baseline = String(baselineScript || '').trim();
  if (!baseline) {
    return { script: '', source: 'template' };
  }

  let token = accessToken;
  if (!token && hasSupabaseConfig()) {
    const supabase = getSupabaseClient();
    const { data } = await supabase.auth.getSession();
    token = data.session?.access_token || null;
  }

  const res = await fetch('/api/chair-script', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ organizationId, baselineScript: baseline, meetingContext }),
    signal,
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    return { script: baseline, source: 'template', error: json.error || 'Refine failed' };
  }

  const script = String(json.script || baseline).trim() || baseline;
  return {
    script,
    source: json.source || 'template',
  };
}
